module.exports = __webpack_public_path__ + "img/login-bg1.689957b7.jpg";